import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './slices/auth-slice';
import { licenReducer } from './slices/licensesSlice';
import {shopReducer} from './slices/shop-slice'
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

import thunk from 'redux-thunk';

// Configure persistence for authReducer - keep menu data but with smart invalidation
const authPersistConfig = {
  key: 'auth',
  storage,
  // Keep all data persisted, we'll handle freshness logic in components
}

// Configure persistence for shopReducer - keep items/categories but with smart invalidation  
const shopPersistConfig = {
  key: 'shop',
  storage,
  // Keep all data persisted, we'll handle freshness logic in components
}

// Configure persistence for licenReducer
const licenPersistConfig = {
  key: 'licen',
  storage,
}

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedShopReducer = persistReducer(shopPersistConfig, shopReducer);
const persistedLicenReducer = persistReducer(licenPersistConfig, licenReducer);

export const store = configureStore({ 
  reducer: { 
    authReducer: persistedAuthReducer, 
    shopReducer: persistedShopReducer, 
    licenReducer: persistedLicenReducer
  }, 
  devTools: process.env.NODE_ENV !== "production", 
  middleware: [thunk], 
});
export const persistor = persistStore(store);